module.exports = __webpack_public_path__ + "static/media/bg_nextgen_mob_ps.ac295220.jpg";